import { Clock } from "lucide-react";

export default function ComingSoon({ module }) {
  const Icon = module.icon;
  return (
    <div className="fade-up" data-testid={`coming-soon-${module.key}`}>
      <div className="panel p-10 max-w-2xl relative overflow-hidden">
        <div className="absolute -right-6 -top-6 opacity-[0.05]"><Icon className="h-48 w-48" /></div>
        <span className="inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-1 rounded bg-amber-50 text-amber-800 border border-amber-200" data-testid="coming-soon-badge">
          <Clock className="h-3.5 w-3.5" />Yakında · Faz {module.phase}
        </span>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-slate-900" data-testid="coming-soon-title">{module.label}</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-md">
          Bu modül geliştirme aşamasındadır. Veri modeli ve yetki altyapısı hazır; ekranlar sonraki fazda devreye alınacak.
        </p>
      </div>
    </div>
  );
}
